
  import {Component, Vue, Watch} from 'vue-property-decorator';
  import {Getter} from "vuex-class";
  import {WordInterface} from "@/Interfaces/WordInterface";
  import {SectionInterface} from "@/Interfaces/SectionInterface";
  import {currentSelectionTimeLimits} from "@/Services/helpers/VuexGetters";

    @Component export default class TitleComponent extends Vue {

      @Getter('fileName') fileName: string;
      @Getter('selectedWords') selectedWords: WordInterface[];
      @Getter('selectedSection') selectedSection: SectionInterface;

      defaultPageTitle: string = null;

      mounted() {
        this.defaultPageTitle = this.$t("title_component.transcription_editor").toString();
        document.title = this.defaultPageTitle;
      }

      @Watch('$store.state.fileName')
      onFileNameChange() {
        this.changePageTitle();
      }
      @Watch('$store.state.selectedWordIds')
      onSelectedWordsChange() {
        this.changePageTitle();
      }
      @Watch('$store.state.selectedSectionId')
      onSelectedSectionChange() {
        this.changePageTitle();
      }

      changePageTitle() {
        const fileName = this.fileName;
        const selectedWords = this.selectedWords;
        if (fileName === '') {
          document.title = this.defaultPageTitle;
        }
        const range = currentSelectionTimeLimits();

        const time = range.start !== null && range.end !== null ? ' (' + range.start + ' - ' + range.end + ')' : '';

        document.title = fileName + time;
      }

    }
